export default __webpack_public_path__ + "static/events-light-fe62f6dd6f9118ddb5c58567308189ff.png";